// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-wrapper[data-v-43f3652a]{display:flex;flex-direction:row;align-items:center}.v-toolbar[data-v-43f3652a]{transition:.6s}.expand[data-v-43f3652a]{height:80px!important;padding-top:10px}", ""]);
// Exports
module.exports = exports;
